import bwmodel from '@/config/bwmodel';
// import  { Base64 }  from 'js-base64/base64.js';
import bridge from '@/config/JSbridge';
import { uploadTrace } from './api';

export const roleInfo = {
  founder: '落魄的创业者',
  fund_manager: '失业的基金经理',
  shareholder: '爱美食的股民',
  speculator: '破产的投机客'
}

export const getStockStr = (incomeDetail = {}) => {
  const {
    halfYearIncomeRatio,
    income,
    incomeRatio,
    month,
    stockName,
  } = incomeDetail;
  const monthStr = `${month}`.slice(4, 6);
  const realMonth = monthStr ? Number(monthStr) + 1 : 1;
  const rise = Number(incomeRatio * 100).toFixed(2);
  const profit = income;
  switch (realMonth) {
    case 1: {
      return `
        <div class='monitor-text'>2024新年伊始，因爆仓而负债累累的你，登上了寒风呼啸的天台。</div>
        <div class='monitor-text'>骤然！天空中冬雷炸响，你眼前闪过一道白光，只觉一阵天旋地转……</div>
        <div class='monitor-text'>你！穿越到了1年前——2023年1月1日！</div>
        <div class='monitor-text'>能够预知未来的你，誓要将失去的一切悉数赢回！</div>
      `;
    }
    case 2: {
      return `
        <div class='monitor-text'>${stockName}1月收益 ${rise}%，你净收益${profit}元！</div>
        <div class='monitor-text'>通过对1月的操作，你知道这还是你熟悉的“战场”，A股市场还是按照记忆中的行情在进行着；</div>
        <div class='monitor-text'>如果记忆没出错的话，2月的人工智能会开始全民讨论，不断发酵！</div>
      `;
    }
    case 3: {
      return `
        <div class='monitor-text'>${stockName}2月收益 ${rise}%，你净收益${profit}元！</div>
        <div class='monitor-text'>人工智能如期开始全面爆发，越来越多巨头下场做属于自己的AI大模型。</div>
        <div class='monitor-text'>市场上也有人对这波AI行情惧高，但你知道这波AI板块行情不会这么快结束。</div>
      `;
    }
    case 4: {
      return `
        <div class='monitor-text'>${stockName}3月收益 ${rise}%，你净收益${profit}元！</div>
        <div class='monitor-text'>看到网上不断讨论的4月10号第一批主板注册制新股上市后，市场会正式进入全面注册制时代。</div>
        <div class='monitor-text'>你知道你的重生记忆，再加上“市值风云”这个专业服务注册制的APP会在这个时代如鱼得水。</div>
      `;
    }
    case 5: {
      return `
        <div class='monitor-text'>${stockName}4月收益 ${rise}%，你净收益${profit}元！</div>
        <div class='monitor-text'>经过4个月的操作，你知道市场还是那个市场，并没有因为你这个重生的“小蝴蝶”发生什么大的改变。</div>
        <div class='monitor-text'>所以现在绝不能放弃这次翻身的机会！</div>
      `;
    }
    case 6: {
      return `
        <div class='monitor-text'>${stockName}5月收益 ${rise}%，你净收益${profit}元！</div>
        <div class='monitor-text'>你的身影经常在龙虎榜上出现，越来越多人崇拜你，开始以“股神”来称呼你。</div>
        <div class='monitor-text'>你对这些虚名早已看淡，但还是会坚持在“市值风云社区”发布些自己的想法，希望能帮助到一些人。</div>
      `;
    }
    case 7: {
      const halfYearProfitRatio = Number(halfYearIncomeRatio * 100).toFixed(2);
      return `
        <div class='monitor-text'>${stockName}6月收益 ${rise}%，你净收益${profit}元！</div>
        <div class='monitor-text'>半年过去，看到账户共赚取到了${halfYearProfitRatio}%的收益，是你曾经想都不敢想的数字！</div>
        <div class='monitor-text'>你把收益分享到了“市值风云社区”，300个前台向你暗送秋波！</div>
        <div class='monitor-text'>但你知道，复利的游戏，最刺激的时刻才刚刚开始……</div>
      `;
    }
    case 8: {
      return `
        <div class='monitor-text'>${stockName}7月收益 ${rise}%，你净收益${profit}元！</div>
        <div class='monitor-text'>你记忆中8月市场有关部门会出“降印花税”、“减持新规”等一系列政策来刺激市场；</div>
        <div class='monitor-text'>刺不刺激市场不知道，但你知道这又会是你账户腾飞的机会。</div>
      `;
    }
    case 9: {
      return `
        <div class='monitor-text'>${stockName}8月收益 ${rise}%，你净收益${profit}元！</div>
        <div class='monitor-text'>已经越来越多人打探你的消息，来联系你；其中不乏各大基金公司、曾经的总舵主，当然也有一些公司的女公关和前台...</div>
        <div class='monitor-text'>但你选择置之不理，他们只会影响你拔刀的速度。</div>
      `;
    }
    case 10: {
      return `
        <div class='monitor-text'>${stockName}9月收益 ${rise}%，你净收益${profit}元！</div>
        <div class='monitor-text'>10月，已经适应重生后生活的你，还是得感叹时间过的真快；</div>
        <div class='monitor-text'>对于之前的2023年10月记忆已经有点模糊，好在你早已记录好了每个月的事件和热股；</div>
      `;
    }
    case 11: {
      return `
        <div class='monitor-text'>${stockName}10月收益 ${rise}%，你净收益${profit}元！</div>
        <div class='monitor-text'>你已经有点厌倦了每天会所的日子，看着桌上刚订的游艇合同，你打算做完12月后就开启新的生活；</div>
        <div class='monitor-text'>虽然股市生活枯燥，但好在还有市值风云社区给生活带来一丝陪伴。</div>
      `;
    }
    case 12: {
      return `
        <div class='monitor-text'>${stockName}11月收益 ${rise}%，你净收益${profit}元！</div>
        <div class='monitor-text'>10万本金炒股，能赚多少钱？</div>
        <div class='monitor-text'>你就是这个问题的答案。</div>
        <div class='monitor-text'>时间再次来到冬天，2023年的最后一个月，</div>
        <div class='monitor-text'>你将为自己传奇的炒股经历，画上句号。</div>
      `;
    }
    default: return ''
  }
}

export const openApp = (schema) => {
  // if (bwmodel.app === 'weibo' || (bwmodel.app === 'dingtalk' && bwmodel.system === 'Android')) {
  //   // 
  // } else 
  // let schemeUrl = encodeURIComponent('storm://app/webview?url=' + Base64.encode(url))
  let schemeUrl = encodeURIComponent(schema)
  let universalUrl = schema
  if (bwmodel.system === 'iPhone') {
    const href = process.env.REACT_APP_appOpenUrl + universalUrl
    window.location.href = href
  } else {
    const href = process.env.downloadUrl + '?ios_scheme=' + schemeUrl + '&android_scheme=' + schemeUrl
    window.location.href = href
  }
}

export const activityShare = (callback) => {
  bridge.callHandler('nativeEvent', {
    event: 'shareLink',
    params: {
      title: `牛回！速来股神模拟器！`,
      desc: '假如2023重来，试试你炒股能赚多少钱',
      thumbUrl: 'https://file.wogoo.com/app/logo/logo7.png',
      linkUrl: process.env.REACT_APP_DEMAND_URL + 'active_31',
    },
  }, () => {
    handleUploadTrace('share', 'click');
    callback && callback();
  })
}

export const activityShareFriend = (income, callback) => {
  bridge.callHandler('nativeEvent', {
    event: 'shareLink',
    params: {
      title: `我全年收益${income}，你呢？`,
      desc: '假如2023重来，试试你炒股能赚多少钱',
      thumbUrl: 'https://file.wogoo.com/app/logo/logo7.png',
      linkUrl: process.env.REACT_APP_DEMAND_URL + 'active_31',
    },
  }, () => {
    handleUploadTrace('share', 'click');
    callback && callback();
  })
}

export const isStorm = bwmodel.app === 'storm';

export function convertCanvasToImg(base64) {
  const myBlob = dataURLtoBlob(base64);
  const myUrl = URL.createObjectURL(myBlob);
  downImg(myUrl);
}

function dataURLtoBlob(dataurl) {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

function downImg(url) {
  let a = document.createElement('a');
  let clickEvent = document.createEvent('MouseEvents');
  a.setAttribute('href', url);
  a.setAttribute('download', 'codeImg');
  a.setAttribute('target', '_blank');
  clickEvent.initEvent('click', true, true);
  a.dispatchEvent(clickEvent);
}

export function getIncomeSplit(income) {
  // debugger
  if (!income) {
    return income;
  }
  
  const [incomeStr, sufix] = `${income}`.split('.');

  const absoluteValue = incomeStr[0] === '-' ? incomeStr.slice(1, incomeStr.length) : incomeStr;
  const unit = incomeStr[0] === '-' ? '-' : '';

  const nextIncome = [...absoluteValue.split('')].reverse().join('');
  const nextIncomeArr = [];
  nextIncomeArr.push(nextIncome.slice(0, 3))
  nextIncomeArr.push(nextIncome.slice(3, 6))
  nextIncomeArr.push(nextIncome.slice(6, 9))
  nextIncomeArr.push(nextIncome.slice(9, 12))
  nextIncomeArr.push(nextIncome.slice(12, 15))
  nextIncomeArr.push(nextIncome.slice(15, 18));
  const finalNum = nextIncomeArr.filter(item => !!item).join(',').split('').reverse().join('');
  return unit + finalNum + (sufix ? `.${sufix}` : '');
}

export const handleUploadTrace = (id, type, args = {}) => {
  const timestamp = `${new Date().valueOf()}`;
  const event = {
    source: isStorm ? 'inside' : 'outside',
    event: type || 'click',
    eventTime: timestamp,
    type: id
  }
  uploadTrace({
    traceStat: JSON.stringify([event]),
    timestamp: timestamp,
    nonce: id
  })
}

export const shareWechart = () => {
  let sendData = {
    event: 'webData',
    params: {
      action: 'essayData',
      data: {
        C_TITLE: '牛回！速来股神模拟器！',
        C_TITLE_IMG: 'https://file.wogoo.com/app/logo/logo7.png',
        C_INTRODUCE: "假如2023重来，试试你炒股能赚多少钱",
        C_IMG: "",
        ARTICLE_ID: 'a76767d26311439786c35ea8dc11a253',
        C_CONTENT: '123',
        shareImg: 'https://file.wogoo.com/app/logo/logo7.png',
        share_url: process.env.REACT_APP_DEMAND_URL + 'active_31',
      }
    }
  }
  bridge.callHandler('nativeEvent', sendData, res => {})
  const event = {
    event: 'shareToSocial',
    params: {
      title: '牛回！速来股神模拟器！',
      subtitle: '假如2023重来，试试你炒股能赚多少钱',
      image: 'https://file.wogoo.com/app/logo/logo7.png',
      url: process.env.REACT_APP_DEMAND_URL + 'active_31',
      articleID: '',
      social: 'wechat'
    }
  }
  bridge.callHandler('nativeEvent', event, res => {
    const result = JSON.parse(res);
    if (result.code === 0) {}
  });

  bridge.callHandler(
    'nativeEvent',
    {
      event: 'nativeControl',
      params: {
        navigation: {
          visibility: false
        },
        container: {},
        bottomToolbar: {
          visibility: false
        }
      }
    },
    () => {}
  );
}

export const sleep = (time) => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(), time);
  });
}


// WEBPACK FOOTER //
// ./src/views/activity_31/stock.js